<template>
  <div class="roleManage">
    <div class="content">
      <div class="Files-top">
        <div class="ic-left">
          <span>角色管理</span>
        </div>
        <div class="btns">
          <el-button type="primary" @click="add_ed(0)" class="last-el-button">新增</el-button>
        </div>
      </div>
      <div class="roleManage-table">
        <el-table :data="tableData" border stripe style="width: 100%" :max-height='heights'>
          <template slot="empty">
            <span class="noData">
              <img src="@/assets/noData.png" alt="暂无数据">
              <span class="text">暂无数据</span>
            </span>
          </template>
          <el-table-column label="序号" width="90" align="center">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="roleName" label="名称" width="690"> </el-table-column>
          <el-table-column prop="remark" label="备注" width="690"> </el-table-column>
          <el-table-column label="操作" align="center">
            <template #default="{row}">
              <span class="buttoned_box">
                <div @click="edit_ed(row)" class="mr-20">
                  <el-tooltip class="item" effect="dark" content="编辑" placement="top">
                    <elIconBtn btnType='edit'></elIconBtn>
                  </el-tooltip>
                </div>
                <div @click="del_ed(row)">
                  <el-tooltip class="item" effect="dark" content="删除" placement="top">
                    <elIconBtn btnType='del'></elIconBtn>
                  </el-tooltip>
                </div>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <downloadTable ref="downloadTable"></downloadTable>
    </div>

    <!-- 新增修改 -->

    <el-dialog width="20%" v-dialogDrag :title="textMap[dialogStatus]" :close-on-click-modal='false'
      :visible.sync="dialogVisible">
      <div style="display: flex;">

        <el-form :model="temp" ref="temp" :rules="rules" style="width: 80%;height: 120px;padding-top: 10px;">
          <el-form-item label="名称:" prop="roleName">
            <el-input v-model="temp.roleName" style=""></el-input>
          </el-form-item>

          <el-form-item label="备注:" prop="remark">
            <el-input v-model="temp.remark"></el-input>
          </el-form-item>

        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogStatus==='edit'?edit_fn('temp'):add_fn('temp')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {findRoleFile,saveRoleFile,deleteRoleFile} from "../../api/zhongshanMeter";

  import downloadTable from '@/components/module/downloadTable/downloadTable.vue'
  import elIconBtn from '@/components/module/iconBtns.vue'
  export default {
    components: {
      downloadTable,
      elIconBtn
    },
    data () {
      return {
        heights: document.getElementById('app').clientHeight-210,//屏幕高度 - 导航栏高度
        loading: true,
        //弹窗
        dialogVisible: false,
        dialogStatus: '',
        textMap: {
          add: "新增角色",
          edit: "编辑角色"
        },
        //新增修改对象
        temp: {
          'roleName': "",
          'remark': "",
        },
        //星号必填
        rules: {
          roleName: [
            {required: true,message: '请输入名称',trigger: 'blur'}
          ]
        },
        //表格数据
        tableData: [],
        //表格选中
        multipleSelection: []

      };
    },

    mounted () {
      this.getList()

    },
    computed: {

    },
    watch: {

    },

    methods: {

      //获取数据
      getList () {
        this.loading=true
        findRoleFile().then(res => {
          if(res.code==200) {
            this.tableData=res.data
            this.loading=false
          }
        })
      },

      // 添加弹窗
      add_ed (v,l) {
        this.temp.roleName=''
        this.temp.remark=''
        this.dialogStatus='add';
        this.dialogVisible=true;
        this.topLevel=v
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });
        // this.temp = { EnergyTypeParentId: v || null};
      },
      // 确认添加
      add_fn (formName) {
        this.$refs[formName].validate(valid => {
          if(valid) {
            var d={
              'roleName': this.temp.roleName,
              'remark': this.temp.remark,
            }
            saveRoleFile(d).then(res => {
              if(res.code==200) {
                this.getList();
                this.dialogVisible=false;
                this.$message({showClose: true,message: '添加成功',type: 'success'});
              } else {
                res.message? this.$message.error(res.message):this.$message.error('添加失败');
              }
            })


          } else {
            return false;
          }
        });
      },

      // 确认编辑
      edit_fn () {
        this.$refs['temp'].validate(valid => {
          if(valid) {
            saveRoleFile(this.temp).then(res => {
              if(res.code==200) {
                this.getList();
                this.dialogVisible=false;
                this.$message({showClose: true,message: '修改成功',type: 'success'});
              } else {
                res.message? this.$message.error(res.message):this.$message.error('修改失败');
              }
            })
          } else {
            return false;
          }
        });
      },
      //编辑弹窗
      edit_ed (v) {
        this.dialogStatus='edit';

        this.temp=Object.assign({},v);

        this.dialogVisible=true;

        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });

      },
      //删除
      del_ed (row) {
        this.$confirm(`是否删除 ${row.roleName}`,'提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          deleteRoleFile({"id": row.id}).then(res => {
            if(res.code==200) {
              this.getList();
              this.$message({showClose: true,message: '删除成功',type: 'success'});
            } else {
              res.message? this.$message.error(res.message):this.$message.error('删除失败');

            }
          })
        }).catch(() => {
          // ...
        });
      },
      //下载表格excel
      exportList () {
        let time=new Date();
        let year=time.getFullYear();
        let month=time.getMonth()+1;
        let day=time.getDate();

        const tHeader=[];
        this.$refs.downloadTable.export2Excel(tHeader,this.tableData,year+"-"+month+"-"+day+'-映射管理','.mapping-table')
      },
      // 转换时间戳
      date_format_fn (value) {
        if(!value) {
          return ""
        }
        let date=new Date(value);
        let Y=date.getFullYear()+'-';
        let M=(date.getMonth()+1<10? '0'+(date.getMonth()+1):date.getMonth()+1)+'-';
        let D=(date.getDate()<10? '0'+(date.getDate()):date.getDate())+' ';

        let h=(date.getHours()<10? '0'+(date.getHours()):date.getHours())+':';
        let m=(date.getMinutes()<10? '0'+(date.getMinutes()):date.getMinutes())+':';
        let s=(date.getSeconds()<10? '0'+(date.getSeconds()):date.getSeconds());
        let strDate=Y+M+D+h+m+s;
        return `'${strDate}'`
      },


    },

  };
</script>

<style lang="scss" scoped>
  .roleManage {
    width: 100%;
    // height: calc(100% - 125px) !important;
    background-color: #ebf4ff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;

    .content {
      width: 100%;
      height: 100%;
      background-color: #fff;

      .Files-top {
        margin: 20px;
      }

      .roleManage-table {
        margin: 0px 20px;

        /deep/.el-table th {
          background-color: #F3F8FF;
          color: #999999;
          border-right: 1px solid #E6E6E6;
          padding: 10px 0px;
          font-weight: bold;
        }

        /deep/.el-table th.is-leaf {
          border-bottom: 0px;
        }

        .status {
          width: 8px;
          height: 8px;
          display: inline-block;
          border-radius: 50%;
          position: relative;
          top: -1px;
        }

        .blue {
          background-color: #52A1FF;

        }

        .ash {
          background-color: #999999;

        }

        .buttoned_box {
          display: flex;
          justify-content: center;
          align-items: center;

          .line {
            display: inline-block;
            width: 1px;
            height: 20px;
            background-color: #E6E6E6;
            margin: 0px 20px;
          }

          .buttoned {
            cursor: pointer;
          }

          /deep/.el-button span {
            font-size: 15px;
            font-weight: 400;
          }
        }
      }

    }

    /deep/.el-dialog__header {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #E6E6E6;

      span {
        color: #67A3ED;
        font-size: 14px;
        font-weight: bold;
      }

      .el-icon-close {
        font-size: 20px !important;
      }

    }

    /deep/.el-dialog__footer {
      margin-top: 20px;
      text-align: right !important;
      border-top: 1px solid #E6E6E6;

      button {
        padding: 8px 17px;
      }
    }

    .demo-temp {
      display: flex;
      flex-wrap: wrap;
    }

    /deep/.el-form-item {
      display: flex;
      margin-left: 20px;
    }

    /deep/.el-form-item__label {
      white-space: nowrap;
      width: 54px;
    }

    /deep/.el-dialog__body {
      padding: 20px 0px 0px 20px !important;
    }

    /deep/.el-input__inner {
      height: 34px;
      line-height: 34px;
    }
  }
</style>